import { render, staticRenderFns } from "./BufferInvoicePdf.vue?vue&type=template&id=36e5907e&scoped=true"
import script from "./BufferInvoicePdf.vue?vue&type=script&lang=js"
export * from "./BufferInvoicePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e5907e",
  null
  
)

export default component.exports